// src/components/data/assignEvaluacionesStore.js
// Datos DEMO para la pantalla de Asignar Evaluaciones

// Cursos administrados por el usuario + módulos
export const assignCourses = [
  {
    id: "curso-te",
    nombre: "Trabajo en Equipo",
    clave: "CUR-001",
    estado: "En curso",
    modules: [
      { id: "te-m1", nombre: "Módulo 1. Fundamentos del trabajo en equipo" },
      { id: "te-m2", nombre: "Módulo 2. Roles y responsabilidades" },
      { id: "te-m3", nombre: "Módulo 3. Resolución de conflictos" },
    ],
  },
  {
    id: "curso-ce",
    nombre: "Comunicación Efectiva",
    clave: "CUR-002",
    estado: "En curso",
    modules: [
      { id: "ce-m1", nombre: "Módulo 1. Conceptos básicos" },
      { id: "ce-m2", nombre: "Módulo 2. Escucha activa" },
      { id: "ce-m3", nombre: "Módulo 3. Comunicación en crisis" },
    ],
  },
  {
    id: "curso-cec",
    nombre: "Código de Ética y Conducta",
    clave: "CUR-003",
    estado: "En curso",
    modules: [
      { id: "cec-m1", nombre: "Módulo 1. Principios del código" },
      { id: "cec-m2", nombre: "Módulo 2. Casos prácticos" },
      { id: "cec-m3", nombre: "Módulo 3. Dilemas éticos" },
    ],
  },
];

// Cuestionarios ya existentes (catálogo demo)
export const initialQuestionnaires = [
  {
    id: "q-te-1",
    titulo: "Diagnóstico Trabajo en Equipo",
    tipo: "Normativo",
    version: "2025",
  },
  {
    id: "q-ce-1",
    titulo: "Estilos de Comunicación",
    tipo: "Normativo",
    version: "2025",
  },
  {
    id: "q-cec-1",
    titulo: "Principios del Código de Ética",
    tipo: "Normativo",
    version: "2025",
  },
];
